import { Component, ViewChild } from "@angular/core";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { EstablishmentTheReserveOfYearsOfService } from "../../models/establishment-the-reserve-of-years-of-service.model";

@Component({
  selector: "establishment-the-reserve-of-years-of-service-form",
  templateUrl: "./establishment-the-reserve-of-years-of-service-form.component.html",
  styleUrls: ["./establishment-the-reserve-of-years-of-service-form.component.scss"],
})
export class EstablishmentTheReserveOfYearsOfServiceFormComponent extends BaseFormComponent<EstablishmentTheReserveOfYearsOfService> {
  public label: string = "استقرار ذخیره سنوات خدمت";
  public dataList: EstablishmentTheReserveOfYearsOfService[];
  @ViewChild("grid") public grid: EditableGridComponent;
  gridColumns: form_control[] = [];
  isRefreshingData: boolean = false;
  DefaultValues: Dictionary = [];
  RemainDays: number = 0;
  HasCalculate: boolean = false;
  async ngOnInit() {
    this.areaName = "Payroll";
    this.apiName = "EstablishmentTheReserveOfYearsOfService";
    this.dataList = [];
    super.ngOnInit();
  }
  setColumnAttribute() {
    this.gridColumns = Object.assign([], this.orignalColumns);
    this.gridColumns.forEach((x) => {
      if (x.name !== "EmploymentStartDate" && x.name !== "BuyInitialAmount" && x.name !== "BuyDelayWork" && x.listVisible === true) x.disabled = true;
    });
  }
  async setData() {
    if (this.isRefreshingData === true) return;

    if (!this.formGroup?.get("IssueYear")?.value || !this.formGroup?.get("IssueMonth")?.value) {
      this.sts.showDialog("سال/ماه استقرار انتخاب نشده است.", "استقرار ذخیره سنوات خدمت");
      return;
    }
    let gridFilter: GridFilter[] = [];
    gridFilter.push({
      Filed: "IssueYear",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.formGroup?.get("IssueYear")?.value,
      Logic: "and",
    });
    gridFilter.push({
      Filed: "IssueMonth",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.formGroup?.get("IssueMonth")?.value,
      Logic: "and",
    });

    this.isRefreshingData = true;
    await this.httpCommonService
      .create(`${this.apiName}/GetEstablishment`, gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          this.HasCalculate = false;
          this.isRefreshingData = false;
          if (data) {
            this.dataList = data as [];
            this.model = this.dataList[0];
            this.setFormGroup(this.model);
            this.formGroup.markAsPristine();
          }
        },
        (error) => {
          this.isRefreshingData = false;
          this.getFailedHelper(error);
        }
      );
  }

  async save() {
    this.selectorService.submitted$.next(this.submitted);
    this.closeModal();
  }
  async _save(event: EstablishmentTheReserveOfYearsOfService) {
    try {
      if (!this.isSaving) {
        if (this.isValid()) {
          this.sts.showToast("info", "", "در حال ذخیره تغییرات...");
          this.isSaving = true;
          this.isSaved = false;
          if (event.Id === undefined || event.Id === 0 || Number.isNaN(event.Id) || event.Id === null) {
            await this.httpCommonService
              .create(this.apiName, event)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (row) => {},
                (error) => this.saveFailedHelper(error)
              );
          } else {
            await this.httpCommonService
              .update(this.apiName, event)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (row) => {},
                (error) => this.saveFailedHelper(error)
              );
          }
        } else {
          this.selectorService.submitted$.next(this.submitted);
        }
      } else {
        this.selectorService.submitted$.next(this.submitted);
      }
    } catch (e) {
      this.saveFailedHelper(e);
    }
  }
}
